// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.code-editor-field-container {
	overflow: auto;
}
.vue-codemirror {
	display: contents;
}
.CodeMirror {
	/* size of editor grows with the parent */
	height: 100%; 
	width: 100%;
	padding-right: 40px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
